import { IShoppingLocation } from "./../../interfaces/IShoppingLocation";

function formattedAddress(shoppingLocation?: IShoppingLocation) {
  if (!shoppingLocation) {
    return null;
  }
  return (
    <>
      {shoppingLocation.street}, {shoppingLocation.city}
    </>
  );
}

function formattedLocation(shoppingLocation?: IShoppingLocation) {
  if (!shoppingLocation) {
    return null;
  }
  return (
    <>
      {shoppingLocation.city && shoppingLocation.zipCode
        ? `${shoppingLocation.city}, ${shoppingLocation.zipCode}`
        : shoppingLocation.zipCode}
    </>
  );
}

function FormattedAddress({
  shoppingLocation,
  isSelectedAddress,
}: {
  shoppingLocation?: IShoppingLocation;
  isSelectedAddress: boolean;
}) {
  return isSelectedAddress
    ? formattedAddress(shoppingLocation)
    : formattedLocation(shoppingLocation);
}

export default FormattedAddress;
